import { schema } from 'normalizr';

const elementTypeSchema = new schema.Entity('types');

export default elementTypeSchema;



// WEBPACK FOOTER //
// ./src/schemas/elementType.js